import { buildInfo } from '@/lib/buildInfo';

/**
 * Kleiner Versions-Stempel unten links. Klick öffnet F12-Console-Hinweis.
 * Auf Hover zeigt es Build-Zeit komplett.
 */
export function VersionPill() {
  const builtDate = new Date(buildInfo.builtAt);
  const short = builtDate.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' }) +
                ' ' + builtDate.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });

  return (
    <div
      title={`Build: ${buildInfo.builtAt}\nApp: ${buildInfo.app}\nWelle: ${buildInfo.wave}\n\nF12 → Console → bamoa.debug()`}
      style={{
        position: 'fixed',
        bottom: 6,
        left: 8,
        fontSize: 10,
        color: 'rgba(255,255,255,0.35)',
        fontFamily: 'ui-monospace, monospace',
        zIndex: 9999,
        pointerEvents: 'auto',
        userSelect: 'none',
        cursor: 'help',
        background: 'rgba(0,0,0,0.4)',
        padding: '2px 6px',
        borderRadius: 3,
        backdropFilter: 'blur(4px)',
      }}
    >
      {buildInfo.app}·{buildInfo.wave}·{short}
    </div>
  );
}
